import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Table, Tooltip, Input, Button, Select } from "antd";

import { usrRole } from "../../utils/dataUtil";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import {
  req_page_tqa_graduate_survey,
  req_downloadfile_tqa_graduate_survey,
} from "../../api";
import { getNowAcademicYear, formateDateDbT } from "../../utils/dateUtil";

class GraduateSurveyInfo extends Component {
  state = {
    loading: false,
    yearGrade: getNowAcademicYear(new Date()) - 2,
    yearSurvey: "1",
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      yearGrade,
      yearSurvey,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_page_tqa_graduate_survey(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      yearGrade,
      yearSurvey,
      token
    );
    this.setState({ loading: false });
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      console.log(items);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      yearGrade,
      yearSurvey,
    } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_graduate_survey(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      yearGrade,
      yearSurvey,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        // const { activityNid } = item
        // Modal.confirm({
        //     title: `您確定刪除此筆數據`,
        //     onOk: () => {
        //         this.api_delete_item(activityNid)
        //     }
        // })
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "畢業學年度",
        dataIndex: "YearGrade",
        width: 25,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "調查區間",
        dataIndex: "YearSurvey",
        width: 20,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "調查對象",
        dataIndex: "AlumniCode",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "科系名稱",
        dataIndex: "DepartmentName",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "問卷版本",
        dataIndex: "Version",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "調查日期",
        dataIndex: "RecordCreateDateTime",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}>
                {" "}
                {formateDateDbT(field)}
              </span>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      yearGrade,
      yearSurvey,
    } = this.state;
    const title = (
      <>
        <span>調查年度</span>
        <Input
          placeholder="畢業學年度"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={yearGrade}
          onChange={(event) => this.setState({ yearGrade: event.target.value })}
        />
        <Select
          value={yearSurvey}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ yearSurvey: value })}
        >
          <Select.Option value="1">畢業一年</Select.Option>
          <Select.Option value="3">畢業三年</Select.Option>
          <Select.Option value="5">畢業五年</Select.Option>
        </Select>
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">其他條件</Select.Option>
          <Select.Option value="DepartmentName">科系名稱</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "4px" }}
        >
          <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(GraduateSurveyInfo);
